module.exports = __webpack_public_path__ + "img/complete-logo.e18ee295.png";